import { render, staticRenderFns } from "./ProfileTrendBox.vue?vue&type=template&id=16ecb020&scoped=true"
import script from "./ProfileTrendBox.vue?vue&type=script&lang=js"
export * from "./ProfileTrendBox.vue?vue&type=script&lang=js"
import style0 from "./ProfileTrendBox.vue?vue&type=style&index=0&id=16ecb020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ecb020",
  null
  
)

export default component.exports